module.exports = __webpack_public_path__ + "img/rowB2.05d7451f.png";